var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useState } from 'react';
import { useRouteChange } from '../_utils/hooks';
import { createPrefixCls } from '../_utils/string';
import Modal from './modal';
const prefixCls = createPrefixCls('confirm');
export const Confirm = (_a) => {
    var { title, content, okText = '确定', cancelText = '取消', onOk, onCancel, onClose, onUnMount } = _a, restProps = __rest(_a, ["title", "content", "okText", "cancelText", "onOk", "onCancel", "onClose", "onUnMount"]);
    const [visible, setVisible] = useState(true);
    useRouteChange(() => {
        setVisible(false);
    });
    const handleOk = useCallback(() => __awaiter(void 0, void 0, void 0, function* () {
        if (onOk) {
            const okRes = yield onOk();
            if (okRes !== false) {
                setVisible(false);
            }
        }
        else {
            setVisible(false);
        }
    }), [onOk]);
    const handleCancel = useCallback(() => {
        setVisible(false);
        onCancel && onCancel();
    }, [onCancel]);
    const handleClose = useCallback(() => {
        setVisible(false);
        onClose && onClose();
        onUnMount && onUnMount();
    }, [onClose, onUnMount]);
    return (React.createElement(Modal, Object.assign({}, restProps, { visible: visible, center: true, onClose: handleClose }),
        React.createElement("div", { className: prefixCls() },
            React.createElement("div", { className: prefixCls('header') },
                React.createElement("div", { className: prefixCls('title') }, title)),
            React.createElement("div", { className: prefixCls('content') }, React.isValidElement(content) ? content : React.createElement("div", { className: prefixCls('content-text') }, content)),
            React.createElement("div", { className: prefixCls('footer') },
                React.createElement("div", { className: prefixCls('btn'), onClick: handleCancel }, cancelText),
                React.createElement("div", { className: prefixCls('btn'), onClick: handleOk }, okText)))));
};
export default Confirm;
